import { Field, useForm } from 'react-final-form';
import styles from './InvoiceProductItem.module.scss';
import { getIn } from 'final-form';
import MeritoButton from '../../../components/common/MeritoButtons/MeritoButtons';
import { RiDeleteBin6Line as RemoveIcon } from 'react-icons/ri';
import OutlinedFormInput from '../../Finance/components/OutlinedFormInput/OutlinedFormInput';
import { onBlurFormatNumber, parseNumberForDB } from '../../../components/functions/utilities';
import { LiaUserEditSolid } from "react-icons/lia";


type Props = {
    fieldIndex: number,
    fieldName: string,
    ipConfigs: any,
}

const InvoiceProductItem = ({ fieldIndex, fieldName, ipConfigs }: Props) => {
    const { mutators, getState } = useForm();

    const productItemValue = getIn(getState().values, fieldName);


    return (
        <div className={styles.itemRootContainer}>
            <div className={styles.topRowContainer}>
                <div className={styles.ipLogoContainer}>
                    {productItemValue?.isNew ?
                        <LiaUserEditSolid />
                        : <img src={ipConfigs[productItemValue?.integrationPartner]?.logo} alt="" />}
                </div>
                <div className={styles.actionBtnContainer}>
                    <MeritoButton onClick={() => {
                        // console.log('remove image');
                        mutators.remove(`invoiceProducts`, fieldIndex)
                    }} type='destructive-ghost' icon={<RemoveIcon />} onlyIcon={true} />
                </div>
            </div>
            <div className={styles.productDetailsRow}>
                <div className={styles.productTitle}>
                    {productItemValue?.productName}
                </div>
                <div className={styles.productDetails}>
                    {productItemValue?.sku ? <div className={styles.productDetailsText}>
                        {productItemValue?.sku}
                    </div> : null}
                    {productItemValue?.sku && productItemValue?.variant ? <div className={styles.productDetailsSeparator}></div> : null}
                    <div className={styles.productDetailsText}>
                        {productItemValue?.variant}
                    </div>
                </div>
            </div>

            <div className={styles.flexFieldContainer}>
                <Field validate={(value) => {
                    if (!value) {
                        return `Enter no. of units purchased from the supplier`
                    }
                }} name={`${fieldName}.unitsPurchased`}>
                    {(props) => {
                        return <OutlinedFormInput
                            {...props.input}
                            label={'Units Purchased'}
                            fieldType='lg'
                            placeholder={'4,000'}
                            showPlaceholder={false}
                            inpuType='number'

                            name={props.input.name}
                            value={props.input.value}
                            onChange={(e) => {
                                // console.log('value', e.target.value)
                                const numericValue = parseNumberForDB(e.target.value, false);
                                // console.log('numeric value', numericValue)
                                props.input.onChange(numericValue);
                            }}
                            onBlur={(e) => {

                                // console.log('onBlur triggering')
                                // if (currentMonthValue?.inEffectValue == MetricValueType.updatedCost && currentMonthValue?.updatedCost && currentMonthValue?.apiCost) {
                                const value = props.input.value;
                                // console.log('value', value);
                                // console.log('value', value);
                                const formattedValue = onBlurFormatNumber(value, 0);
                                // console.log('formattedValue', formattedValue);
                                props.input.onChange(formattedValue);
                                console.log('inputValue', value)
                                props.input.onBlur(e);
                            }}
                            error={props.meta.error}
                            touched={props.meta.touched}
                            isCurrency={true}
                            maxLength={21}
                        />
                    }}
                </Field>
                <Field validate={(value) => {
                    if (!value) {
                        return `Enter the total cost for this product`
                    }
                }} name={`${fieldName}.amount`}>
                    {(props) => {
                        return <OutlinedFormInput
                            {...props.input}
                            label={'Total Cost on Invoice'}
                            fieldType='lg'
                            placeholder={'1,00,000'}
                            showPlaceholder={false}
                            inpuType='number'

                            name={props.input.name}
                            value={props.input.value}
                            onChange={(e) => {
                                // console.log('value', e.target.value)
                                const numericValue = parseNumberForDB(e.target.value, false);
                                // console.log('numeric value', numericValue)
                                props.input.onChange(numericValue);
                            }}
                            onBlur={(e) => {

                                // console.log('onBlur triggering')
                                // if (currentMonthValue?.inEffectValue == MetricValueType.updatedCost && currentMonthValue?.updatedCost && currentMonthValue?.apiCost) {
                                const value = props.input.value;
                                // console.log('value', value);
                                // console.log('value', value);
                                const formattedValue = onBlurFormatNumber(value, 0);
                                // console.log('formattedValue', formattedValue);
                                props.input.onChange(formattedValue);
                                console.log('inputValue', value)
                                props.input.onBlur(e);
                            }}
                            error={props.meta.error}
                            touched={props.meta.touched}
                            isCurrency={true}
                            maxLength={21}
                        />
                    }}
                </Field>
            </div>


        </div>
    )
}

export default InvoiceProductItem;